<template>
  <div>
    <el-row class="u-mt-10 u-mb-20">
      <el-col :xs="24" :sm="16" :md="16">
        <el-select v-model="filtro.modalidade" placeholder="Modalidade" clearable @change="load">
          <el-option label="Creche" value="creche"></el-option>
          <el-option label="Pré-escola" value="pre"></el-option>
          <el-option label="Fundamental" value="fundamental"></el-option>
          <el-option label="EJA" value="eja"></el-option>
          <el-option label="Integral" value="integral"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" class="u-text-right">
        <router-link to="/admin/merenda/pnae-parametros/cadastro" class="btn-new-register">
          <el-button type="primary">NOVO PARÂMETRO</el-button>
        </router-link>
      </el-col>
    </el-row>

    <div class="container-table">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="hidden-mobile" style="width: 70px;">cod</th>
            <th>Modalidade</th>
            <th class="hidden-mobile u-text-center" style="width: 120px;">Idade</th>
            <th class="u-text-right" style="width: 90px;">kcal</th>
            <th class="u-text-right hidden-mobile" style="width: 80px;">Prot. (g)</th>
            <th class="u-text-right hidden-mobile" style="width: 80px;">Carb. (g)</th>
            <th class="u-text-right hidden-mobile" style="width: 80px;">Lip. (g)</th>
            <th class="u-text-right hidden-mobile" style="width: 90px;">Sódio (mg)</th>
            <th class="u-text-right" style="width: 90px;">% AF mín.</th>
            <th class="u-text-center" style="width: 80px;">Ativo</th>
            <th style="width: 130px;" class="u-text-center">Ação</th>
          </tr>
        </thead>
        <tbody v-if="statusList">
          <tr v-for="item in items" :key="item.id">
            <td class="hidden-mobile">{{ item.id }}</td>
            <td>{{ rotuloModalidade(item.modalidade) }}</td>
            <td class="hidden-mobile u-text-center">{{ formatIdade(item) }}</td>
            <td class="u-text-right">{{ formatNum(item.kcal_recomendado, 0) }}</td>
            <td class="u-text-right hidden-mobile">{{ formatNum(item.proteina_g, 1) }}</td>
            <td class="u-text-right hidden-mobile">{{ formatNum(item.carboidrato_g, 1) }}</td>
            <td class="u-text-right hidden-mobile">{{ formatNum(item.lipidio_g, 1) }}</td>
            <td class="u-text-right hidden-mobile">{{ formatNum(item.sodio_mg_max, 0) }}</td>
            <td class="u-text-right">{{ formatNum(item.pct_af_minimo, 2) }}%</td>
            <td class="u-text-center">{{ item.ativo ? 'SIM' : 'NÃO' }}</td>
            <td class="u-text-center acao">
              <router-link :to="'/admin/merenda/pnae-parametros/edit/' + item.id" class="link-icon u-mr-10" style="color: rgba(0, 0, 0, 0.87) !important;">
                <el-button type="info" title="Editar" icon="el-icon-edit" size="mini" plain></el-button>
              </router-link>
              <el-button @click="deleteItem(item.id)" title="Excluir" type="danger" icon="el-icon-delete" size="mini" plain></el-button>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!statusList" class="u-text-center u-mt-25">
        <img src="/public/img/loading-bar.gif" />
      </div>

      <el-row :gutter="10" v-if="statusList">
        <el-col :xs="24" :sm="12" :md="12">
          <div class="u-text-left u-mt-10">
            Mostrando {{ paginate.from }} até {{ paginate.to }} de {{ paginate.qtdItens }} registros encontrados.
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" v-if="paginate.qtdItens > 30">
          <div class="u-text-right">
            <el-pagination :current-page="paginate.page" class="u-mt-10" :total="paginate.qtdItens"
              @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    statusList: false,
    filtro: { modalidade: '' },
    paginate: { page: 1, qtdItens: null, from: '', to: '' },
    items: []
  }),
  mounted () { this.load() },
  methods: {
    load () {
      this.statusList = false
      this.items = []
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/pnae-parametro/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth)
        .then(response => {
          this.items = response.data.data
          this.paginate.qtdItens = response.data.total
          this.paginate.from = response.data.from
          this.paginate.to = response.data.to
          this.statusList = true
        }).catch((error) => { this.$store.commit('throwException', error) })
    },
    rotuloModalidade (m) {
      const map = { creche: 'Creche', pre: 'Pré-escola', fundamental: 'Fundamental', eja: 'EJA', integral: 'Integral' }
      return map[m] || m || '-'
    },
    formatIdade (item) {
      if (item.idade_min === null && item.idade_max === null) return '-'
      if (item.idade_max === null) return `${item.idade_min}+ anos`
      if (item.idade_min === null) return `até ${item.idade_max} anos`
      return `${item.idade_min}–${item.idade_max} anos`
    },
    formatNum (v, casas) {
      if (v === null || v === undefined || v === '') return '-'
      return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
    },
    deleteItem (id) {
      this.$msgbox.confirm('Tem certeza que deseja excluir este parâmetro?', 'Atenção', { confirmButtonText: 'Sim', cancelButtonText: 'Não', type: 'warning' })
        .then(() => {
          window.eventBus.$emit('loading', true)
          this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/pnae-parametro/delete/` + id, this.$store.getters.getHeaderAuth)
            .then(() => {
              window.eventBus.$emit('loading', false)
              window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
              this.load()
            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
        }).catch(() => { })
    },
    getPagePagination (page) {
      this.paginate.page = page
      this.load()
    }
  }
}
</script>
